import React from 'react';
import * as _ from 'lodash';

import { Information } from './common';
import { LoadingModal } from '../modals/common/LoadingModal';
import { messageUtility } from '../../utilities/messageUtility';
import { WorkersApi } from '../../services/workers/WorkersApi';
import PrintUtility from '../../utilities/printUtility';
import { EXPORT_WORKERS_COMPANY_MAX_LENGTH } from '../../utilities/constants';

export const WorkersExportExcelDialog = ({
  visible,
  downloadItems,
  onClose,
  selectedCompanyName,
  maxWorkerCount,
}) => {
  const getMessage = () => {
    const isMultiPart = downloadItems && downloadItems.length > 1;

    return (
      <React.Fragment>
        <div>
          <p className='description'>
            {`作業員の情報が${maxWorkerCount}件を超えていますので、ファイルを分割して出力します。`}
          </p>
          <p className='description'>
            下記のリンクをクリックしてダウンロードしてください。
          </p>
        </div>

        <ul className='download-group'>
          {_.map(downloadItems, item => (
            <DownloadLink
              key={item.id}
              {...item}
              isMultiPart={isMultiPart}
              selectedCompanyName={selectedCompanyName}
            />
          ))}
        </ul>
      </React.Fragment>
    );
  };

  return (
    <Information
      title='作業員一覧を出力する'
      rootClassName='WorkersExportExcelDialog'
      visible={visible}
      message={getMessage()}
      buttonText={messageUtility.getMessage('I-000-017')}
      onClose={onClose}
    />
  );
};

class DownloadLink extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
    };
    this.isDownloading = false;
  }

  handleDownload = () => {
    if (this.isDownloading) {
      return;
    }
    this.isDownloading = true;
    const { id, src, selectedCompanyName } = this.props;
    if (!src) {
      return;
    }

    this.setState({ isLoading: true });

    WorkersApi.getExportExcelFile(src)
      .then(response => {
        const fileName = `作業員マスタ_${selectedCompanyName.slice(
          0,
          EXPORT_WORKERS_COMPANY_MAX_LENGTH
        )}_${id}.xlsx`;
        PrintUtility.printBlob(response, fileName);
      })
      .finally(() => {
        this.setState({ isLoading: false });
        this.isDownloading = false;
      });
  };

  render() {
    const { id } = this.props;
    const { isLoading } = this.state;

    return (
      <React.Fragment>
        <LoadingModal visible={isLoading} />

        <li key={id} className='download-group__item'>
          <span className='download-group__link-marker'>●</span>
          <div className='download-group__link' onClick={this.handleDownload}>
            {`${id}番目のファイルを出力する`}
          </div>
        </li>
      </React.Fragment>
    );
  }
}

export default WorkersExportExcelDialog;



// WEBPACK FOOTER //
// ./src/components/modals/WorkersExportExcelDialog.jsx